import {
  CREATE_LEAD_BY_CHANNEL,
  CREATE_LEAD_BY_CHANNEL_ERROR,
  CREATE_LEAD_BY_CHANNEL_CLEAN,
  CLEAN_CREATE_LEAD_BY_CHANNEL_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function createLeadByChannelReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_LEAD_BY_CHANNEL:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case CREATE_LEAD_BY_CHANNEL_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CREATE_LEAD_BY_CHANNEL_CLEAN:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_CREATE_LEAD_BY_CHANNEL_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
